import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';

import { cn } from 'cn';

// Upstream shadcn base-vega ships `data-horizontal:` / `data-vertical:`
// selectors, but base-ui's Separator emits `data-orientation="horizontal"`
// / `data-orientation="vertical"` — so the shipped classes never match and
// the element renders at 0×0. Selectors below are corrected to match the
// actual attribute base-ui emits. See shadcn-ui/ui#9196 (https://github.com/shadcn-ui/ui/issues/9196) 
function Separator({
  className,
  orientation = 'horizontal',
  ...props
}: SeparatorPrimitive.Props) {
  return (
    <SeparatorPrimitive
      data-slot="separator"
      orientation={orientation}
      className={cn(
        'tw:shrink-0 tw:bg-border tw:data-[orientation=horizontal]:h-px tw:data-[orientation=horizontal]:w-full tw:data-[orientation=vertical]:w-px tw:data-[orientation=vertical]:self-stretch',
        className
      )}
      {...props}
    />
  );
}

export { Separator };
